module.exports = __webpack_public_path__ + "assets/img/3_1211_big.6da41462.jpg";